import {
    DirectGoalCostType,
    DirectPromotionCampainGoalDto,
    DirectPromotionCampainUI,
    DirectPromotionDto,
    DirectPromotionUI,
    DirectSpendLimitType,
} from '../../data-layer/direct/types';
import { getContentPromotionGoalsSettings } from '../../utils/getContentPromotionGoalsSettings';

export const toPromotionDto = (data: DirectPromotionUI): DirectPromotionDto => {
    const { businessId, campaign, feedSettings } = data;
    const { goals } = campaign;
    const goalsIds = Object.keys(campaign.goals);
    const regionsIds = Object.keys(campaign.regions).map((id) => Number(id));

    const result: DirectPromotionDto = {
        business_id: businessId,
        campaign_data: {
            start_date: campaign.startDate,
            weekly_limit: campaign.weeklyLimit,
            region_ids: regionsIds,
            login: campaign.login,
            tracking_params: campaign.utmParams,
            strategy_type: campaign.strategyType,
            pay_for: campaign.payFor,
            budget_type: campaign.budgetType,
            spend_limit_type: campaign.spendLimitType,
            ...getSpendLimitAmount(campaign),
        },
        feed_settings: {
            banned_post_ids: feedSettings.posts,
            use_all_posts: feedSettings.useAllPosts,
            freshness_days: feedSettings.freshnessDays ?? 0,
        },
    };

    if (campaign.counters.length > 0) {
        result.campaign_data.counter_ids = campaign.counters;
    }

    result.campaign_data.goals = goalsIds.map((id) => {
        const goal: DirectPromotionCampainGoalDto = { goal_id: id };
        const { disableCost, showCostType } = getContentPromotionGoalsSettings({
            selectedGoals: campaign.goals,
            strategyType: campaign.strategyType,
            spendLimitType: campaign.spendLimitType,
        });

        if (disableCost) {
            return goal;
        }

        const goalData = goals[id];

        if (showCostType && goalData.costType === DirectGoalCostType.DYNAMIC) {
            goal.is_metrika_source_of_value = true;
        } else {
            goal.cost = goalData.cost ?? 0;
        }

        return goal;
    });

    return result;
};

export const getSpendLimitAmount = (campaign: DirectPromotionCampainUI) => {
    if (campaign.spendLimitType === DirectSpendLimitType.AVERAGE_CPC) {
        return {
            average_cpc: campaign.spendLimitAmount,
        };
    }

    if (campaign.spendLimitType === DirectSpendLimitType.CRR) {
        return {
            crr: campaign.spendLimitAmount,
        };
    }

    // дополнительных полей не требуется
    return {};
};
